import { makeAutoObservable } from 'mobx';

import { RisingKeywordModel } from '@popularKeyword/common-types';

class RisingKeywordStore {
  risingKeywordData: RisingKeywordModel | null = null;

  risingTotalDataCount = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setRisingKeywordData = (data: RisingKeywordModel) => {
    this.risingKeywordData = data;
  };

  setRisingTotalItemCount = (count: number) => {
    this.risingTotalDataCount = count;
  };
}

export default new RisingKeywordStore();
